module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/f183922e3ee0beddc89bf9e6b31030f3.svg";